import React from 'react'

import Table from '../../components/BPMTable/TableComponents/TableWrapper/SetupTableData'
import RankingSpendsTableCreator from '../../tableDefinitions/Ranking/RankingSpendsTableCreator'
import tableCreatorCreatorFactoryCreator from '../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'

function RankingSpendsTable(props) {
    var tableCreatorCreator = tableCreatorCreatorFactoryCreator.getTableCreatorCreatorFromIdentifier(RankingSpendsTableCreator.getId(), {tcFilters: props.filters})
    tableCreatorCreator.setParentProps(props)
    const tableCreator = tableCreatorCreator.getTableCreator('Ranking Spends')

    return (
        <Table
            TableCreator={tableCreator}
            stickyHeader
        />
    )
}

export default (RankingSpendsTable)
